<ins-content-container [ngStyle]="{'height':'100%' }" class="appContentContainer"></ins-content-container>
